import React from 'react'

const KeyedCipherEncryption = ({ plainText, cipherText, ogKey, sortedKey }) => {

    var plainTextArray = plainText.split("");
    var cipherTextArray = cipherText.split("");
    var ogKeyArray = ogKey.split("");
    var sortedKeyArray = sortedKey.split("");

    return (
        <div>
            <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 10px 0" }}>Encryption</p>

            <div style={{ textAlign: "left", display: "flex" }}>
                <div style={{ display: "inline", textAlign: "right", minWidth: "13rem" }}>
                    <div>
                        <p style={{ display: "inline" }}>Plain Text:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Original Key:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Sorted Key:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Cipher Text:</p>
                    </div>
                </div>
                <div style={{ display: "inline" }}>
                    <div className='wrapper'>
                        {plainTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {ogKeyArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {sortedKeyArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {cipherTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KeyedCipherEncryption